// Refreshify theme JS — cart drawer + AJAX add-to-cart
(function () {  var mobileMenu = document.querySelector('[data-mobile-menu]');
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mobile-menu-open]')) { mobileMenu.classList.add('is-open'); }
    if (e.target.closest('[data-mobile-menu-close]')) { mobileMenu.classList.remove('is-open'); }
  });
  var overlay = document.querySelector('[data-cart-overlay]');

  function openCart() { if (overlay) overlay.classList.add('is-open'); }
  function closeCart() { if (overlay) overlay.classList.remove('is-open'); }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); }
  });

  function renderCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function refreshDrawer() {
    fetch('/?section_id=cart-drawer')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newInner = doc.querySelector('[data-cart-drawer-inner]');
        var target = document.querySelector('[data-cart-drawer-inner]');
        if (newInner && target) {
          target.innerHTML = newInner.innerHTML;
          bindRemoveButtons();
        }
      });
  }

  function bindRemoveButtons() {
    document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-cart-remove');
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            renderCartCount(cart.item_count);
            refreshDrawer();
          });
      });
    });
  }
  bindRemoveButtons();

  document.querySelectorAll('[data-add-to-cart]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-add-btn]');
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: form.querySelector('[name="id"]').value,
          quantity: 1
        })
      })
        .then(function (res) { return res.json(); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          renderCartCount(cart.item_count);
          openCart();
          refreshDrawer();
        })
        .catch(function () {
          if (btn) btn.textContent = 'Try again';
        })
        .finally(function () {
          if (btn) {
            btn.disabled = false;
            if (btn.textContent === 'Adding…') btn.textContent = 'Add to cart';
          }
        });
    });
  });
})();
document.querySelectorAll('[data-accordion-trigger]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    btn.closest('.rf-mobile-accordion').classList.toggle('is-open');
  });
});